import React from 'react';
import '../css/PlacementCell.css';

const PlacementCell = () => {
  // Array holding placeholder recruiter image names or placeholders matching the 4x5 grid layout matrix
  const recruiterLogos = [
    { id: 1, name: "Reliance", url: "https://upload.wikimedia.org/wikipedia/commons/9/99/Reliance_Industries_Logo.svg" },
    { id: 2, name: "L&T", url: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Larsen_%26_Toubro_logo.svg" },
    { id: 3, name: "Tata", url: "https://upload.wikimedia.org/wikipedia/commons/8/8f/Tata_logo.svg" },
    { id: 4, name: "SAIL", url: "https://upload.wikimedia.org/wikipedia/en/b/b3/Steel_Authority_of_India_logo.svg" },
    { id: 5, name: "Adani", url: "https://upload.wikimedia.org/wikipedia/commons/3/3a/Adani_Group_Logo.svg" },
    { id: 6, name: "Suzuki", url: "https://upload.wikimedia.org/wikipedia/commons/1/12/Suzuki_logo_2.svg" },
    { id: 7, name: "Toyota", url: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Toyota_logo_%282020%29.svg" },
    { id: 8, name: "HP", url: "https://upload.wikimedia.org/wikipedia/commons/1/19/Hindustan_Petroleum_Logo.svg" },
    { id: 9, name: "ONGC", url: "https://upload.wikimedia.org/wikipedia/commons/0/05/ONGC_Logo.svg" },
    { id: 10, name: "NTPC", url: "https://upload.wikimedia.org/wikipedia/commons/1/1d/NTPC_Logo.svg" },
    { id: 11, name: "BHEL", url: "https://upload.wikimedia.org/wikipedia/commons/a/af/Bhel_logo.svg" },
    { id: 12, name: "IOCL", url: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Indian_Oil_Logo.svg" },
    { id: 13, name: "NEC", url: "https://upload.wikimedia.org/wikipedia/commons/d/df/NEC_logo.svg" },
    { id: 14, name: "Essar", url: "https://upload.wikimedia.org/wikipedia/commons/d/d4/Essar_Group_logo.svg" },
    { id: 15, name: "Aditya Birla", url: "https://upload.wikimedia.org/wikipedia/commons/4/41/Aditya_Birla_Group_Logo.svg" },
    { id: 16, name: "L&T Hydrocarbon", url: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Larsen_%26_Toubro_logo.svg" },
    { id: 17, name: "AM/NS", url: "https://upload.wikimedia.org/wikipedia/commons/1/1a/ArcelorMittal_logo.svg" },
    { id: 18, name: "KEC", url: "https://upload.wikimedia.org/wikipedia/commons/3/30/KEC_International_Logo.svg" },
    { id: 19, name: "Sobha", url: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Sobha_Limited_logo.svg" },
    { id: 20, name: "Godrej", url: "https://upload.wikimedia.org/wikipedia/commons/4/4d/Godrej_Group_Logo.svg" }
  ];

  return (
    <section className="gfi-placement-section">
      <div className="gfi-placement-outer-capsule">
        
        {/* LEFT BLOCK: ANALYTICS DETAILS AND COUNTERS */}
        <div className="gfi-placement-content-side">
          <span className="gfi-placement-pill-badge">PLACEMENT SUPPORT</span>
          <h2 className="gfi-placement-main-heading">
            Dedicated Placement <br />Support Cell
          </h2>
          <p className="gfi-placement-body-text">
            We have a dedicated placement team that provides job assistance across India and guidance for international opportunities, including Gulf countries. Our focus is to make students job-ready through practical training, skill development, and interview preparation.
          </p>

          {/* DYNAMIC PERFORMANCE STATISTICS MATRIX */}
          <div className="gfi-placement-stats-block">
            <div className="gfi-stat-row">
              <div className="gfi-stat-box">
                <span className="gfi-stat-number">200+</span>
                <span className="gfi-stat-label">COMPANIES</span>
              </div>
              <div className="gfi-stat-box">
                <span className="gfi-stat-number">80%</span>
                <span className="gfi-stat-label">PLACEMENT RATE</span>
              </div>
              <div className="gfi-stat-box">
                <span className="gfi-stat-number">₹80k+</span>
                <span className="gfi-stat-label">AVG. SALARY (GULF)</span>
              </div>
            </div>
            
            <div className="gfi-stat-row lower-row-offset">
              <div className="gfi-stat-box">
                <span className="gfi-stat-number">₹22k+</span>
                <span className="gfi-stat-label">AVG. SALARY (INDIA)</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT BLOCK: 4X5 HIGH RESOLUTION RECRUITERS GRID SYSTEM */}
        <div className="gfi-placement-grid-side">
          <span className="gfi-grid-top-caption">TRUSTED BY 200+ COMPANIES</span>
          
          <div className="gfi-recruiter-logos-matrix">
            {recruiterLogos.map((logo) => (
              <div key={logo.id} className="gfi-recruiter-card">
                <img 
                  src={logo.url} 
                  alt={`${logo.name} Recruiter Partner Logo`} 
                  className="gfi-recruiter-img" 
                  onError={(e) => {
                    // Failover textual placeholder if internet asset vector rendering is blocked
                    e.target.style.display = 'none';
                    e.target.parentNode.innerText = logo.name;
                  }}
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default PlacementCell;